module.exports = __webpack_public_path__ + "img/14_42.52d0c6ff.png";